import { Typography } from "@/frontend/shared/ui/Typography/Typography";
import styles from "./ArchivedCompaniesHeader.module.scss";
import clsx from "clsx";
import { Dispatch, SetStateAction, useRef, useState } from "react";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { CaretLeftIcon, FilterIcon } from "@/frontend/shared/assets/icons";
import { ActionsHeader, TActionsHeader } from "@/frontend/components/ActionsHeader/ActionsHeader";
import { Badge } from "@/frontend/shared/ui/Badge/Badge";

type TPortfolioHeaderProps = {
  className?: string;
  numFilters: number;
  setAreFiltersOpen: Dispatch<SetStateAction<boolean>>;
  areFiltersOpen: boolean;
} & TActionsHeader;

export function ArchivedCompaniesHeader({
  className,
  selected,
  onChange,
  triggerRefetch,
  allCompaniesData,
  setAreFiltersOpen,
  numFilters,
  areFiltersOpen
}: TPortfolioHeaderProps) {
  return (
    <div className={clsx(styles.container, className)}>
      <div className={styles.leftSideContainer}>
        <NormalButton
          size="large"
          className={styles.filterBtn}
          variant="secondary"
          onClick={() => setAreFiltersOpen((prev) => !prev)}
        >
          {areFiltersOpen ? <CaretLeftIcon /> : <FilterIcon />}
          {numFilters > 0 && (
            <Badge bgColor="var(--innovera-orange500)" className={styles.badge}>
              {numFilters}
            </Badge>
          )}
          <Typography variant="label-4" color="greyscale900">
            Filters
          </Typography>
        </NormalButton>
        <Typography variant="heading-6" color="greyscale800">
          Archive
        </Typography>
      </div>
      <div className={styles.rightSideContainer}>
        <div className={styles.controlsContainer}>
          <ActionsHeader
            // data={data}
            className={styles.actionHeader}
            selected={selected}
            onChange={onChange}
            triggerRefetch={triggerRefetch}
            allCompaniesData={allCompaniesData}
          />
        </div>
      </div>
    </div>
  );
}
